  import { ServerResponse } from 'data/types';
  import { AnyAction } from 'redux';
  import { AxiosPromise, AxiosResponse } from 'axios';
  import { ThunkAction } from 'redux-thunk';
  import { RootState } from 'data/root.reducers';

  export const API_PATH_FILTERS = '/filter';

  export const GO_TO_FILTERS_LIST = 'GO_TO_FILTERS_LIST';
  export const GET_FILTERS_LIST = 'GET_FILTERS_LIST';
  export const GET_FILTERS_LIST_PENDING = 'GET_FILTERS_LIST_PENDING';
  export const GET_FILTERS_LIST_FULFILLED = 'GET_FILTERS_LIST_FULFILLED';
  export const GET_FILTERS = 'GET_FILTERS';
  export const GET_FILTERS_PENDING = 'GET_FILTERS_PENDING';
  export const GET_FILTERS_FULFILLED = 'GET_FILTERS_FULFILLED';
  export const CREATE_FILTERS = 'CREATE_FILTERS';
  export const CREATE_FILTERS_PENDING = 'CREATE_FILTERS_PENDING';
  export const CREATE_FILTERS_FULFILLED = 'CREATE_FILTERS_FULFILLED';
  export const CREATE_FILTERS_REJECTED = 'CREATE_FILTERS_REJECTED';
  export const UPDATE_FILTERS = 'UPDATE_FILTERS';
  export const UPDATE_FILTERS_FULFILLED = 'UPDATE_FILTERS_FULFILLED';
  export const UPDATE_FILTERS_REJECTED = 'UPDATE_FILTERS_REJECTED';
  export const DELETE_FILTERS = 'DELETE_FILTERS';
  export const DELETE_FILTERS_FULFILLED = 'DELETE_FILTERS_FULFILLED';
  export const DELETE_FILTERS_REJECTED = 'DELETE_FILTERS_REJECTED';
  export const SELECT_FILTERS = 'SELECT_FILTERS';

  export const OPEN_FILTERS_CREATE_PAGE = 'OPEN_FILTERS_CREATE_PAGE';
  export const CLOSE_FILTERS_CREATE_PAGE = 'CLOSE_FILTERS_CREATE_PAGE';
  export const OPEN_FILTERS_EDIT_PAGE = 'OPEN_FILTERS_EDIT_PAGE';
  export const CLOSE_FILTERS_EDIT_PAGE = 'CLOSE_FILTERS_EDIT_PAGE';
  export const SET_FILTERS_LOADING = 'SET_FILTERS_LOADING';
  export const GO_TO_FILTERS_VIEW = 'GO_TO_FILTERS_VIEW';

  export enum FiltersPrivileges {
    View = 'cf_view',
    Edit = 'cf_write',
    Delete = 'cf_delete',
  }

  export interface Filters {
    id: string
    fgId: string
    fId: string
    type: string
    value: string
    prefix: string
    application: string
  }

  export interface FiltersState {
    entities: Filters[]
    single: Filters | null
    selected: Filters[]
    createdId: string | null
    ui: FiltersUIState
  }

  export type FiltersUIState = {
    isCreatePopupOpen: boolean
    isEditPopupOpen: boolean
    isLoading: boolean
  }

  export interface GoToFiltersListAction extends AnyAction {
    type: typeof GO_TO_FILTERS_LIST
  }

  export interface openFiltersCreatePageAction extends AnyAction {
    type: typeof OPEN_FILTERS_CREATE_PAGE
  }

  export interface closeFiltersCreatePageAction extends AnyAction {
    type: typeof CLOSE_FILTERS_CREATE_PAGE
  }

  export interface openFiltersEditPageAction extends AnyAction {
    type: typeof OPEN_FILTERS_EDIT_PAGE
  }

  export interface closeFiltersEditPageAction extends AnyAction {
    type: typeof CLOSE_FILTERS_EDIT_PAGE
  }

  export interface SetFiltersLoadingAction extends AnyAction {
    type: typeof SET_FILTERS_LOADING
    payload: { isLoading: boolean }
  }

  export interface GetFiltersListAction extends AnyAction {
    type: typeof GET_FILTERS_LIST
    payload: AxiosPromise<ServerResponse<Filters>>
  }

  export interface GetFiltersListPendingAction extends AnyAction {
    type: typeof GET_FILTERS_LIST_PENDING
    payload: null
  }

  export interface GetFiltersListFulfilledAction extends AnyAction {
    type: typeof GET_FILTERS_LIST_FULFILLED
    payload: AxiosResponse<ServerResponse<Filters>>
  }

  export interface GetFiltersAction extends AnyAction {
    type: typeof GET_FILTERS
    payload: AxiosPromise<ServerResponse<Filters>>
  }

  export interface GetFiltersPendingAction extends AnyAction {
    type: typeof GET_FILTERS_PENDING
    payload: null
  }

  export interface GetFiltersFulfilledAction extends AnyAction {
    type: typeof GET_FILTERS_FULFILLED
    payload: AxiosResponse<ServerResponse<Filters>>
  }

  export interface CreateFiltersThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
  export interface CreateFiltersAction extends AnyAction {
    type: typeof CREATE_FILTERS
    payload: AxiosPromise<ServerResponse<Filters>>
  }

  export interface CreateFiltersPendingAction extends AnyAction {
    type: typeof CREATE_FILTERS_PENDING
    payload: null
  }

  export interface CreateFiltersFulfilledAction extends AnyAction {
    type: typeof CREATE_FILTERS_FULFILLED
    payload: AxiosResponse<ServerResponse<Filters>>
  }

  export interface CreateFiltersRejectedAction extends AnyAction {
    type: typeof CREATE_FILTERS_REJECTED
    payload: AxiosResponse<ServerResponse<Filters>>
  }

  export interface UpdateFiltersThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
  export interface UpdateFiltersAction extends AnyAction {
    type: typeof UPDATE_FILTERS
    payload: AxiosPromise<ServerResponse<Filters>>
  }

  export interface UpdateFiltersFulfilledAction extends AnyAction {
    type: typeof UPDATE_FILTERS_FULFILLED
    payload: AxiosResponse<ServerResponse<Filters>>
  }

  export interface UpdateFiltersRejectedAction extends AnyAction {
    type: typeof UPDATE_FILTERS_REJECTED
    payload: AxiosResponse<ServerResponse<Filters>>
  }

  export interface DeleteFiltersThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
  export interface DeleteFiltersAction extends AnyAction {
    type: typeof DELETE_FILTERS
    payload: AxiosPromise<ServerResponse<Filters>>
  }

  export interface DeleteFiltersFulfilledAction extends AnyAction {
    type: typeof DELETE_FILTERS_FULFILLED
    payload: AxiosResponse<ServerResponse<Filters>>
  }

  export interface DeleteFiltersRejectedAction extends AnyAction {
    type: typeof DELETE_FILTERS_REJECTED
    payload: AxiosResponse<ServerResponse<Filters>>
  }

  export interface SelectFiltersAction extends AnyAction{
    type: typeof SELECT_FILTERS
    payload: Filters[]
  }

  export interface GoToFiltersView extends AnyAction{
    type: typeof GO_TO_FILTERS_VIEW
  }

  export type FiltersActionTypes =
    GoToFiltersListAction |
    openFiltersCreatePageAction |
    closeFiltersCreatePageAction |
    openFiltersEditPageAction |
    closeFiltersEditPageAction |
    SetFiltersLoadingAction |
    GetFiltersListAction |
    GetFiltersListPendingAction |
    GetFiltersListFulfilledAction |
    GetFiltersAction |
    GetFiltersPendingAction |
    GetFiltersFulfilledAction |
    CreateFiltersAction |
    CreateFiltersPendingAction |
    CreateFiltersFulfilledAction |
    CreateFiltersRejectedAction |
    UpdateFiltersAction |
    UpdateFiltersFulfilledAction |
    UpdateFiltersRejectedAction |
    DeleteFiltersAction |
    DeleteFiltersFulfilledAction |
    DeleteFiltersRejectedAction |
    SelectFiltersAction |
    GoToFiltersView;
